export const SET_MERCHANTS = "merchants.SET_MERCHANTS";
export const SET_MERCHANT_REQUIRED = "merchants.SET_MERCHANT_REQUIRED";
